export const facilityLanguageIsoToShortLocale = (facilityLanguageIso: string) => {
    console.log(`facilityLanguageIsoToShortLocale(${facilityLanguageIso})`)

    if(!facilityLanguageIso) return

    const shortLocale = facilityLanguageIso.split('-')[0];

    return shortLocale
}